import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class LoaderService {
  isLoading = false;
  show() {
    Promise.resolve().then(() => {
      this.isLoading = true;
    });
  }
  hide() {
    Promise.resolve().then(() => {
      this.isLoading = false;
    });
  }
}
